export default __webpack_public_path__ + "static/media/umi_banner_10.e84b6e1e.png";